import { API_URL } from '../environment';
export const PATH_URL = API_URL;